import { jsx } from "panel";
import { selx } from "clsx";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { ButtonTheme } from "common/components/button/constants";
import { MarkdownEl } from "common/components/markdown";
import { TooltipEl } from "../tooltip";
import { CheckboxEl } from "../checkbox";
import { ButtonEl } from "../button";
import styles from "./index.module.styl";
export function template() {
  const parent = this.parentNode;
  return this.shouldRenderTour() ? /* @__PURE__ */ jsx(TooltipEl, {
    props: {
      parentEl: parent
    },
    attrs: {
      elref: `tooltip`,
      "is-tooltip-tour": true,
      "always-show": true,
      placement: Placement.Top,
      "image-src": this.params.imageSrc,
      size: DisplaySize.Large
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.mpTourBody)
  }, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.mpTitle)
  }, this.params.title), /* @__PURE__ */ jsx(MarkdownEl, {
    sel: selx(styles.mpMarkdown),
    attrs: { text: this.params.markdownText }
  })), this.params.showDoNotShowCheckbox ? /* @__PURE__ */ jsx(CheckboxEl, {
    sel: selx(styles.mpDismiss),
    on: { click: this.handleCheckboxToggle },
    attrs: { checked: this.isCheckboxMarked(), elref: `checkbox` }
  }, `Do not show again`) : null, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.mpCtaContainer)
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Secondary, elref: `secondaryButton` },
    on: { click: this.handleSecondaryButtonClik },
    sel: ".secondary-cta"
  }, this.params.secondaryButtonLabel), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Primary, elref: `primaryButton` },
    on: { click: this.handlePrimaryButtonClick },
    sel: selx(styles.mpPrimaryCta)
  }, this.params.primaryButtonLabel))) : null;
}
